module.exports = __webpack_public_path__ + "static/media/vf_wearring_core.b64fbfe8.svg";